<div>
  <ion-icon name="star" *ngFor="let num of [1, 2, 3, 4, 5, 6, 7]" (click)="readonly ? null : rate(num)" [ngStyle]="{ 'color': getColor(num)}" style="font-size: 24px;"></ion-icon>
  <br>
  <ion-label position="floating">{{label}}</ion-label>
</div>
